var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.417 2.90747C26.4333 3.34337 25.3765 3.63789 24.2656 3.77102C25.3989 3.09243 26.2683 2.01564 26.6783 0.733868C25.618 1.36297 24.4435 1.82008 23.1935 2.06512C22.1921 1.00012 20.7666 0.333313 19.1879 0.333313C16.1579 0.333313 13.7003 2.79084 13.7003 5.82327C13.7003 6.2521 13.7498 6.66915 13.8417 7.07206C9.27892 6.84233 5.23685 4.65695 2.52957 1.33706C2.05833 2.14995 1.78737 3.09243 1.78737 4.09617C1.78737 5.99999 2.75695 7.68114 4.2284 8.66486C3.32833 8.6354 2.48245 8.38918 1.7426 7.97802V8.04871C1.7426 10.7077 3.63346 12.9261 6.14517 13.4303C5.68335 13.5552 5.19915 13.6211 4.69964 13.6211C4.34621 13.6211 4.00102 13.5881 3.66644 13.5245C4.36506 15.704 6.39139 17.2921 8.79354 17.3345C6.91447 18.8071 4.54766 19.6848 1.97704 19.6848C1.53408 19.6848 1.097 19.6589 0.666992 19.6083C3.09624 21.1669 5.98024 22.074 9.07865 22.074C19.175 22.074 24.6944 13.7118 24.6944 6.45945C24.6944 6.22383 24.6885 5.98585 24.6779 5.75023C25.75 4.97504 26.6807 4.01017 27.4146 2.911L27.417 2.90747Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5867c4ee.svg";
export { ForwardRef as ReactComponent };